import { render } from "./GainImportFilesListCard.vue?vue&type=template&id=320c58d7&ts=true"
import script from "./GainImportFilesListCard.vue?vue&type=script&lang=ts"
export * from "./GainImportFilesListCard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__